var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casi-loading-container"},[_c('div',{staticClass:"loading-card"},[_c('i',{staticClass:"el-icon-loading loading-icon"}),_c('h3',{staticClass:"loading-title"},[_vm._v("正在登录中")]),_c('p',{staticClass:"loading-desc"},[_vm._v("请稍候，系统正在完成身份验证...")])])])
}]

export { render, staticRenderFns }